export namespace DispatchErrorConstants {
  export const OUTSIDE_OPERATING_HOURS: RegExp = /must be within operating hours/;
  export const DRIVER_HAS_ACTIVE_RESERVATIONS = /driver has one or more reservations assigned/;
}
